import React from "react";
import { Layout } from "../../components";
import styled from "styled-components";

const Wrapper = styled.div`
    padding: 20px;
`; 

const MyProfile = () => (
  <Layout>
    <Wrapper>Página em contrução...</Wrapper>
  </Layout>
);

export default MyProfile;
